import { makePOSTRequest } from 'utils/api/makePOSTRequest';
import { url } from 'utils/urls';

export const postContentResponse = questionResponseDetails => {
    return new Promise(function (resolve, reject) {
        let xhr = new XMLHttpRequest();
        xhr.open('POST', url.api.questionResponses);
        xhr.onload = function () {
            if (this.status >= 200 && this.status < 300) {
                resolve({
                    status: this.status,
                    response: xhr.response.length > 0 ? JSON.parse(xhr.response) : xhr.response
                })

            } else {
                reject({
                    status: this.status,
                    statusText: xhr.statusText,
                    response: xhr.response
                });
            }
        };
        xhr.onerror = function () {
            reject({
                status: this.status,
                statusText: xhr.statusText
            });
        };
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.send(JSON.stringify(questionResponseDetails));
    })
};
